module.exports = __webpack_public_path__ + "static/media/error.5652a3ed.svg";